import { useEffect, useState } from "react";
import { IsReadTypeEnum, NotificationType, NotificationTypes } from "../../../../../interfaces/general";
import { Tab } from "@headlessui/react";
import Button from "../../../../../utils/component/button/button.index";
import { ButtonSize } from "../../../../../utils/component/button/button.interface";
import noNotif from "../../../../../assets/images/svg/no-notif.svg";
import NotificationItem from "../notificationItem/notificationItem.index";

interface NotificationHeaderProps {
    filters: NotificationTypes[];
    notifications: NotificationType[] | undefined;
    onSelect: (filters: NotificationTypes[]) => void;
    onDelete: (id: number) => void;
    onUpdate: (id: number, type: IsReadTypeEnum) => void;
    onClick: any;
}

function classNames(...classes: any[]) {
    return classes.filter(Boolean).join(" ");
}

export function NotificationList({ notifications, onDelete, onUpdate, onClick }: NotificationHeaderProps) {
    const [notificationState, setNotificationState] = useState<any>();

    useEffect(() => {
        setNotificationState([
            [notifications ? notifications : [], { payload: "همه", length: (notifications ? notifications : []).length }],
            [
                notifications
                    ? notifications.filter((notif: { type: NotificationTypes }) => [NotificationTypes.SHARED_FILE].includes(notif.type))
                    : [],
                {
                    payload: "اشتراک فایل",
                    length: (notifications
                        ? notifications.filter((notif: { type: NotificationTypes }) => [NotificationTypes.SHARED_FILE].includes(notif.type))
                        : []
                    ).length
                }
            ],
            [
                notifications ? notifications.filter((notif: { type: NotificationTypes }) => [NotificationTypes.PLAN].includes(notif.type)) : [],
                {
                    payload: "فضای ذخیره‌سازی",
                    length: (notifications
                        ? notifications.filter((notif: { type: NotificationTypes }) => [NotificationTypes.PLAN].includes(notif.type))
                        : []
                    ).length
                }
            ],
            [
                notifications
                    ? notifications.filter((notif: { type: NotificationTypes }) =>
                          [NotificationTypes.LINK_UPLOUD, NotificationTypes.LINK_UPLOUD_IN_SHARED_FOLDER].includes(notif.type)
                      )
                    : [],
                {
                    payload: "آپلود",
                    length: (notifications
                        ? notifications.filter((notif: { type: NotificationTypes }) =>
                              [NotificationTypes.LINK_UPLOUD, NotificationTypes.LINK_UPLOUD_IN_SHARED_FOLDER].includes(notif.type)
                          )
                        : []
                    ).length
                }
            ],
            [
                notifications
                    ? notifications.filter((notif: { type: NotificationTypes }) => [NotificationTypes.USER_LOGIN].includes(notif.type))
                    : [],
                {
                    payload: "حساب کاربری",
                    length: (notifications
                        ? notifications.filter((notif: { type: NotificationTypes }) => [NotificationTypes.USER_LOGIN].includes(notif.type))
                        : []
                    ).length
                }
            ]
        ]);
    }, [notifications]);

    return (
        <div className="w-full py-3">
            <Tab.Group>
                <Tab.List className="flex justify-between px-3 overflow-x-auto no-scrollbar">
                    {notificationState
                        ? notificationState.map((notif: any) => (
                              <Tab
                                  key={notif[1].payload}
                                  className={({ selected }) =>
                                      classNames(
                                          "flex justify-between items-center gap-1 min-w-fit p-1 text-secondary-500 text-xs outline-none focus:outline-none",
                                          selected ? "border-b-[3px] border-primary-600" : ""
                                      )
                                  }
                              >
                                  {({ selected }) => (
                                      <>
                                          <span className={`${selected && "text-primary-600"}`}>{notif[1].payload}</span>
                                          <span
                                              className={`w-[22px] h-[18px] flex items-center justify-center text-white rounded-[5px] ${selected ? "bg-primary-600" : "bg-secondary-400"}`}
                                          >
                                              {notif[1].length}
                                          </span>
                                      </>
                                  )}
                              </Tab>
                          ))
                        : ""}
                </Tab.List>

                <Tab.Panels className="mt-2 h-96 overflow-y-auto no-scrollbar">
                    {notificationState && notificationState[0] && notificationState[0].length > 0 ? (
                        notificationState.map((notif: any) => {
                            return (
                                <Tab.Panel key={notif[1].payload}>
                                    {notif[0].length ? (
                                        notif[0].map((item: any) => {
                                            return <NotificationItem notification={item} onDelete={onDelete} onUpdate={onUpdate} />;
                                        })
                                    ) : (
                                        <div className="flex flex-col items-center mt-4">
                                            <img src={noNotif} alt="noNotif" className="mb-9" />
                                            <h3 className="text-secondary-800 text-[16px] font-[800] mb-[6px]">در حال حاضر هیچ اعلانی وجود ندارد!</h3>
                                            <p className="text-[11px] text-secondary-500 mb-4">
                                                هنگامی که اعلان دریافت کنید، در اینجا نشان داده می شوند.
                                            </p>
                                            <Button text="به‌روزرسانی" autoFocus={true} size={ButtonSize.MD} onClick={onClick} />
                                        </div>
                                    )}
                                </Tab.Panel>
                            );
                        })
                    ) : (
                        <div className="flex flex-col items-center mt-4">
                            <img src={noNotif} alt="noNotif" className="mb-9" />
                            <h3 className="text-secondary-800 text-[16px] font-[800] mb-[6px]">در حال حاضر هیچ اعلانی وجود ندارد!</h3>
                            <p className="text-[11px] text-secondary-500 mb-4">هنگامی که اعلان دریافت کنید، در اینجا نشان داده می شوند.</p>
                            <Button text="به‌روزرسانی" autoFocus={true} size={ButtonSize.MD} onClick={onClick} />
                        </div>
                    )}
                </Tab.Panels>
            </Tab.Group>
        </div>
    );
}
